"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blobToFile = void 0;
var blobToFile = function (blob, fileName) {
    var file = blob;
    file.lastModifiedDate = new Date();
    file.name = fileName;
    return file;
};
exports.blobToFile = blobToFile;
